import React, { Fragment, useState } from "react";
import moment from "moment";
import _ from "lodash";
import PropTypes from "prop-types";
import { Divider } from "../../../commons/elements";
import Dropdown from "../../../commons/dropdown";
import orderItem from "../../../prop-types/orderItem";
import OrderItem from "./order-item";
import { orderHistoryDropdown } from "../../../constants";

function OrderHistoryList({ purchases }) {
  const [timeframe, setTimeframe] = useState(1);

  const filterPurchases = () => {
    const currentDate = new Date();
    switch (timeframe) {
      case 0:
        return purchases.filter((p) => {
          const datePurchased = new Date(p.date);
          return (
            moment(datePurchased).week() === moment(currentDate).week() &&
            datePurchased.getFullYear() === currentDate.getFullYear()
          );
        });
      case 1:
        return purchases.filter((p) => {
          const datePurchased = new Date(p.date);
          return (
            datePurchased.getMonth() === currentDate.getMonth() &&
            datePurchased.getFullYear() === currentDate.getFullYear()
          );
        });
      default:
        return purchases;
    }
  };

  const filteredPurchases = purchases ? filterPurchases() : [];

  return (
    <div className="order-items-container mb-3">
      <div className="filter-container py-3">
        <Dropdown
          selectedItemCallback={(value) => setTimeframe(value)}
          name="This Month"
          items={orderHistoryDropdown}
        />
      </div>
      {(!!filteredPurchases.length &&
        _.reverse(filteredPurchases).map((p, i, arr) => (
          <Fragment key={p.id}>
            <Divider />
            <OrderItem item={p} />
            {i === arr.length - 1 ? <Divider /> : null}
          </Fragment>
        ))) || (
        <div className="no-orders-container">
          <p className="no-orders-message">
            {orderHistoryDropdown[timeframe].noOrdersMsg}
          </p>
        </div>
      )}
      {filteredPurchases.find((p) => p.refunded) && (
        <div className="refund-message mt-3">
          <i>* Indicates full or partial refund. Click the order for details</i>
        </div>
      )}
    </div>
  );
}

OrderHistoryList.defaultProps = {
  purchases: null
};

OrderHistoryList.propTypes = {
  purchases: PropTypes.arrayOf(orderItem)
};

export default OrderHistoryList;
